import { render, staticRenderFns } from "./ForeignMobile.vue?vue&type=template&id=113d5e7e&scoped=true&"
import script from "./ForeignMobile.vue?vue&type=script&lang=js&"
export * from "./ForeignMobile.vue?vue&type=script&lang=js&"
import style0 from "./ForeignMobile.vue?vue&type=style&index=0&id=113d5e7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113d5e7e",
  null
  
)

export default component.exports